import React from 'react';
import { Info, Check } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const INCLUDED = [
  'Automated portal & email bill collection',
  'AI parsing with validation & exception handling',
  'Property, unit & meter onboarding and management',
  'Push meter reads to ENERGY STAR Portfolio Manager',
  'Energy-market insights',
  'Payment files, NACHA generation & payment recording',
  'Full bill lifecycle management, end to end',
];

/**
 * Small "i" icon with a rich tooltip that reframes the $3.25/credit price as
 * access to the whole platform (not just parsing). Reused on the Bill Credits
 * tab and the pricing cards.
 */
export default function CreditValueInfo({ unitUsd = 3.25, className = '' }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid="credit-value-info"
            aria-label="What a bill credit includes"
            className={`inline-flex items-center justify-center text-muted-foreground hover:text-emerald-600 transition-colors ${className}`}
          >
            <Info className="h-4 w-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="start"
          className="max-w-[320px] p-3.5 text-left"
          data-testid="credit-value-tooltip"
        >
          <div className="text-[13px] font-semibold text-foreground mb-1">
            More than parsing — ${Number(unitUsd).toFixed(2)} per account unlocks the whole platform for that bill
          </div>
          <p className="text-[11px] text-muted-foreground mb-2 leading-snug">
            1 credit = one account on a bill (a bill covering 3 accounts uses 3 credits). Each
            credit runs that account&apos;s <span className="font-medium text-foreground">entire lifecycle</span>:
          </p>
          <ul className="space-y-1">
            {INCLUDED.map((item) => (
              <li key={item} className="flex items-start gap-1.5 text-[11px] text-foreground leading-snug">
                <Check className="h-3 w-3 text-emerald-600 mt-0.5 shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
